import { Box, Typography, TypographyVariant } from '@mui/material';
import { StyleObj } from '../../@types';
import { formatNumberToStandard } from '../../utils';

const styles: StyleObj = {
  container: {
    width: '50%',
    maxWidth: 260,
    p: { xs: 1, md: 1.5 },
    borderRadius: { xs: 1, md: 2 },
    border: '1px solid',
    '> h6': {
      fontFamily: 'sans-serif',
    },
  },
};

type BettingInfoDisplayProps = {
  label: string;
  value?: string;
  backgroundColor: string;
  borderColor: string;
  variant?: TypographyVariant;
  currency?: string;
};

const CURRENCY_LOCALES_MAP: Record<string, string> = {
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  JPY: 'ja-JP',
  INR: 'hi-IN',
  BDT: 'bn-BD',
  CNY: 'zh-CN',
  RUB: 'ru-RU',
  CAD: 'en-CA',
  AUD: 'en-AU',
};

export const getCurrencySymbol = (currency?: string) => {
  if (!currency) return '';
  const locale = CURRENCY_LOCALES_MAP[currency] || 'en-US';
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).formatToParts(0);

  const symbolPart = parts.find((part) => part.type === 'currency');
  return symbolPart?.value || currency;
};

const BettingInfoDisplay = ({
  label,
  value,
  backgroundColor,
  borderColor,
  variant = 'subtitle1',
  currency,
}: BettingInfoDisplayProps) => {
  return (
    <Box
      sx={{
        ...styles.container,
        backgroundColor,
        borderColor,
      }}
    >
      <Typography
        variant={variant}
        sx={{
          fontWeight: 500,
        }}
      >
        {label}: {getCurrencySymbol(currency)}
        {formatNumberToStandard(Number(value)) || 0}
      </Typography>
    </Box>
  );
};

export default BettingInfoDisplay;
